import { createVNode as _createVNode, resolveComponent as _resolveComponent, toDisplayString as _toDisplayString, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, Fragment as _Fragment } from "vue"
import _imports_0 from '@/app/ui/assets/svg/bg-dot-pattern.svg'
import _imports_1 from '@/app/ui/assets/svg/bg-client-circle.svg'


const _hoisted_1 = {
  class: "flex flex-col pb-6 px-0 bg-lp-white w-full",
  style: {"border-radius":"25px","box-shadow":"2px 4px 8px 2px rgba(0, 0, 0, 0.07)"}
}
const _hoisted_2 = /*#__PURE__*/_createVNode("img", {
  class: "absolute bottom-0 right-0 opacity-25 size-full",
  src: _imports_0
}, null, -1)
const _hoisted_3 = { class: "flex flex-row justify-between mb-6" }
const _hoisted_4 = { class: "flex flex-row gap-2" }
const _hoisted_5 = /*#__PURE__*/_createVNode("div", {
  class: "rounded-md bg-yellow-lp-300",
  style: {"min-width":"6px","min-height":"1px"}
}, null, -1)
const _hoisted_6 = { class: "flex-grow text-xl text-left content-center text-white font-semibold" }
const _hoisted_7 = {
  key: 0,
  class: "px-10 rounded-2xl content-center font-bold",
  style: 
            `max-height: 28px; min-height: 28px; color: #B82025; background-color: #F8E9E9;`
          
}
const _hoisted_8 = { class: "text-left content-center text-white font-semibold text-4xl" }
const _hoisted_9 = {
  key: 0,
  class: "mt-6 text-white"
}
const _hoisted_10 = { class: "text-xs" }
const _hoisted_11 = { class: "font-semibold text-xl" }
const _hoisted_12 = { class: "px-6" }
const _hoisted_13 = {
  key: 0,
  class: "relative w-full py-2 px-3 rounded-xl bg-gray-lp-1000 aspect-auto mt-3"
}
const _hoisted_14 = { class: "text-base font-semibold pr-16 text-gray-lp-300" }
const _hoisted_15 = { class: "text-sm text-black-lp-100 my-2" }
const _hoisted_16 = { class: "text-xs text-black-lp-100" }
const _hoisted_17 = { class: "text-xs text-gray-lp-800" }
const _hoisted_18 = { class: "flex mt-3 gap-1" }
const _hoisted_19 = { class: "relative w-full py-2 px-3 rounded-xl bg-gray-lp-1000 aspect-auto" }
const _hoisted_20 = /*#__PURE__*/_createVNode("img", {
  class: "absolute bottom-0 right-0 size-full",
  src: _imports_1
}, null, -1)
const _hoisted_21 = { class: "text-base font-semibold mb-2 pr-16 text-gray-lp-300" }
const _hoisted_22 = { class: "text-xs text-black-lp-100" }
const _hoisted_23 = { class: "relative w-full py-2 px-3 rounded-xl bg-gray-lp-1000 aspect-auto" }
const _hoisted_24 = /*#__PURE__*/_createVNode("img", {
  class: "absolute bottom-0 right-0 size-full",
  src: _imports_1
}, null, -1)
const _hoisted_25 = { class: "text-base font-semibold mb-2 pr-8 text-gray-lp-300" }
const _hoisted_26 = { class: "text-xs text-black-lp-100" }
const _hoisted_27 = { class: "text-gray-lp-800" }
const _hoisted_28 = { class: "text-xs text-black-lp-100 mt-2" }
const _hoisted_29 = { class: "text-gray-lp-800" }
const _hoisted_30 = {
  key: 1,
  class: "text-xs text-black-lp-100 mt-2"
}
const _hoisted_31 = {
  class: "grid grid-cols-2 mt-1 gap-1",
  "data-testid": "info-detail-client-audit-info"
}
const _hoisted_32 = { class: "w-full py-2 px-3 rounded-xl bg-red-lp-50 aspect-auto" }
const _hoisted_33 = /*#__PURE__*/_createVNode("p", { class: "text-xs font-medium mb-1 text-gray-lp-800" }, "Dibuat oleh", -1)
const _hoisted_34 = { class: "flex items-center gap-x-1 min-w-0" }
const _hoisted_35 = { class: "relative w-full py-2 px-3 rounded-xl bg-red-lp-50 aspect-auto" }
const _hoisted_36 = { class: "text-xs font-medium mb-1 text-gray-lp-800" }
const _hoisted_37 = { class: "flex items-center gap-x-1 min-w-0" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Icons = _resolveComponent("Icons")!

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", {
      class: ["relative flex flex-col py-8 px-6 overflow-hidden", {
        'bg-red-lp-100': _ctx.isClientParent,
        'bg-purple-lp-900': !_ctx.isClientParent
      }],
      style: {"border-radius":"25px"}
    }, [
      _hoisted_2,
      _createVNode("div", _hoisted_3, [
        _createVNode("div", _hoisted_4, [
          _hoisted_5,
          _createVNode(_component_Icons, { name: "icon-partner" }),
          _createVNode("div", _hoisted_6, _toDisplayString(_ctx.isClientParent === true ? _ctx.$t("clientManagement.infoDetailClient.parentClient") : _ctx.$t("clientManagement.infoDetailClient.branchClient")), 1)
        ]),
        (_ctx.clientFreeze)
          ? (_openBlock(), _createBlock("div", _hoisted_7, _toDisplayString(_ctx.$t("clientManagement.infoDetailClient.freeze")), 1))
          : (_openBlock(), _createBlock("div", {
              key: 1,
              class: "px-10 rounded-2xl content-center font-bold",
              style: 
            `max-height: 28px; min-height: 28px; color: ${_ctx.statusTextColor}; background-color: ${_ctx.statusBgColor};`
          
            }, _toDisplayString(_ctx.statusString), 5))
      ]),
      _createVNode("div", _hoisted_8, _toDisplayString(_ctx.clientName), 1),
      (_ctx.showBalance)
        ? (_openBlock(), _createBlock("div", _hoisted_9, [
            _createVNode("p", _hoisted_10, _toDisplayString(_ctx.$t("clientManagement.infoDetailClient.availableBalance")), 1),
            _createVNode("p", _hoisted_11, _toDisplayString(_ctx.balance), 1)
          ]))
        : _createCommentVNode("", true)
    ], 2),
    _createVNode("div", _hoisted_12, [
      (_ctx.clientFreeze)
        ? (_openBlock(), _createBlock("div", _hoisted_13, [
            _createVNode("p", _hoisted_14, _toDisplayString(_ctx.$t("clientManagement.infoDetailClient.freezeReason")), 1),
            _createVNode("p", _hoisted_15, _toDisplayString(_ctx.freezeReason), 1),
            _createVNode("p", _hoisted_16, _toDisplayString(_ctx.freezeUpdatedAt), 1),
            _createVNode("p", _hoisted_17, _toDisplayString(_ctx.freezeUpdatedBy), 1)
          ]))
        : _createCommentVNode("", true),
      _createVNode("div", _hoisted_18, [
        _createVNode("div", _hoisted_19, [
          _hoisted_20,
          _createVNode("p", _hoisted_21, _toDisplayString(_ctx.$t("clientManagement.infoDetailClient.createdDate")), 1),
          _createVNode("p", _hoisted_22, _toDisplayString(_ctx.createdAt), 1)
        ]),
        _createVNode("div", _hoisted_23, [
          _hoisted_24,
          _createVNode("p", _hoisted_25, _toDisplayString(_ctx.$t("clientManagement.infoDetailClient.updatedDate")), 1),
          (_ctx.isClientParent)
            ? (_openBlock(), _createBlock(_Fragment, { key: 0 }, [
                _createVNode("p", _hoisted_26, [
                  _createVNode("strong", _hoisted_27, _toDisplayString(_ctx.$t("clientManagement.infoDetailClient.price")) + " : ", 1),
                  _createTextVNode(" " + _toDisplayString(_ctx.rateUpdatedAt), 1)
                ]),
                _createVNode("p", _hoisted_28, [
                  _createVNode("strong", _hoisted_29, _toDisplayString(_ctx.$t("clientManagement.infoDetailClient.detail")) + " : ", 1),
                  _createTextVNode(" " + _toDisplayString(_ctx.detailUpdatedAt), 1)
                ])
              ], 64))
            : (_openBlock(), _createBlock("p", _hoisted_30, _toDisplayString(_ctx.updatedAt), 1))
        ])
      ]),
      _createVNode("div", _hoisted_31, [
        _createVNode("div", _hoisted_32, [
          _hoisted_33,
          _createVNode("div", _hoisted_34, [
            _createVNode(_component_Icons, {
              name: "user",
              class: "w-4 text-black-lp-100"
            }),
            _createVNode("p", {
              class: "text-xs text-black-lp-300 font-semibold capitalize truncate",
              title: _ctx.createdBy
            }, _toDisplayString(_ctx.createdBy), 9, ["title"])
          ])
        ]),
        _createVNode("div", _hoisted_35, [
          _createVNode("p", _hoisted_36, _toDisplayString(_ctx.$t("clientManagement.infoDetailClient.updatedBy")), 1),
          _createVNode("div", _hoisted_37, [
            _createVNode(_component_Icons, {
              name: "user",
              class: "w-4 text-black-lp-100"
            }),
            _createVNode("p", {
              class: "text-xs text-black-lp-300 font-semibold capitalize truncate",
              title: _ctx.updatedBy
            }, _toDisplayString(_ctx.updatedBy), 9, ["title"])
          ])
        ])
      ])
    ])
  ]))
}